import { string, object, number } from 'yup';

const schema = object().shape({
  experience_rating: number().integer().positive('requiredField'),
  pickup_on_time: string().required('requiredField'),
  beer_was_cold: string().required('requiredField'),
  correct_packaging: string().required('requiredField')
});

export default schema;